// src/utils/files.js

// dataURI -> raw base64 only (no "data:...;base64,")
export function extractBase64Data(dataURI) {
  if (!dataURI || typeof dataURI !== "string") return "";
  const idx = dataURI.indexOf("base64,");
  if (idx === -1) return ""; // not base64
  return dataURI.substring(idx + "base64,".length);
}

export function nameWithoutExt(name) {
  if (!name) return "file";
  const i = name.lastIndexOf(".");
  return i > 0 ? name.slice(0, i) : name;
}

export async function fileToBase64Sync(file) {
  if (!file) return null;

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(extractBase64Data(reader.result));
    reader.onerror = reject;
  });
}

export async function fileToPayload(file) {
  if (!file) return null;

  const base64 = await fileToBase64Sync(file); // raw base64 only
  return {
    base64, // ✅ raw base64
    name: nameWithoutExt(file.name),
    type: file.type || "",
    size: file.size ?? null,
  };
}

export async function filesToBase64Array(list) {
  const arr = Array.isArray(list) ? list : Array.from(list || []);
  const base64s = await Promise.all(arr.map((f) => fileToBase64Sync(f)));
  return arr.map((f, i) => ({
    base64: base64s[i],
    name: nameWithoutExt(f.name),
    type: f.type || "",
    size: f.size ?? null,
  }));
}
